export default "__VITE_ASSET__BBrvDj$9__"